import React, { useContext } from 'react'
import { StateContext } from '../../services/StateService'
import ProductSelector from './ProductSelector'
import CTASection from './CTASection'
import WhereToBuyController from './WhereToBuyController'
import ServiceLocator from './ServiceLocator'
import '../../css/PurchaseOptions.scss'

const PurchaseOptions = ({
    prodOptButtonRef,
    getProductEndpoint,
    handleProductSelectorRequest
}) => {
    const { isParent, ctaInfo } = useContext(StateContext)

    return (
        <div className="sps2-pdp_purchase--container">
            {isParent && !ctaInfo?.pdpSelectorOverride && (
                <ProductSelector
                    prodOptButtonRef={prodOptButtonRef}
                    handleProductSelectorRequest={handleProductSelectorRequest}
                />
            )}
            <WhereToBuyController getProductEndpoint={getProductEndpoint} />
            <CTASection />
            {ctaInfo?.serviceLocatorWidgetId && ctaInfo?.serviceLocatorSubId && (
                <ServiceLocator
                    widgetId={ctaInfo.serviceLocatorWidgetId}
                    subId={ctaInfo.serviceLocatorSubId}
                />
            )}
        </div>
    )
}

export default PurchaseOptions
